import { updateState } from '../../shared/mutations';
import { VideoTemplateStateContent } from '../../types';
import { LayerMoveOption } from './types';
import { moveLayer } from './utils';

export const setNewLayerPosition = (
  state: VideoTemplateStateContent,
  layerId: string,
  moveTo: LayerMoveOption,
): VideoTemplateStateContent => {
  const newOrder = moveLayer(state, layerId, moveTo);

  return updateState(state, {
    layers: {
      ...state.layers,
      order: newOrder,
    },
  });
};
